import { createApp } from 'vue'
import CompoundInterest from './CompoundInterest.vue'
import './assets/global.css'

createApp(CompoundInterest).mount('#compound-interest')
